var map = {
	"./Airplane_GameIcon.png": 601,
	"./Alchemix_GameIcon.png": 52698,
	"./CarRacer_GameIcon.png": 52240,
	"./Climbing_GameIcon.png": 60036,
	"./CrossTheRoad_GameIcon.png": 74278,
	"./Default_GameIcon.png": 56430,
	"./FlyingCar_GameIcon.png": 81208,
	"./FlyingCarpet_GameIcon.png": 99107,
	"./FrogJourney_GameIcon.png": 18293,
	"./GardenRage_GameIcon.png": 73927,
	"./JapaneseGarden_GameIcon.png": 46357,
	"./LineRoller_GameIcon.png": 88905,
	"./Mind4_GameIcon.png": 91775,
	"./MineCart_GameIcon.png": 24954,
	"./Octopulse_GameIcon.png": 54391,
	"./SkiLiner_GameIcon.png": 96192,
	"./SpaceBurger_GameIcon.png": 5848,
	"./Stardust_GameIcon.png": 67459,
	"./ToapRun_GameIcon.png": 6254,
	"./TowerBuilder_GameIcon.png": 53055,
	"./WitcherDefense_GameIcon.png": 60535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23334;